export const FreeDinnerLicense = [
  // { name: '강동희', number: '46993' },
  // { name: '강문석', number: '78209' },
  // { name: '강민범', number: '62187' },
  // { name: '강상규', number: '46195' },
  // { name: '강상윤', number: '49774' },
  // { name: '강은택', number: '68930' },
  // { name: '경현우', number: '90143' },
  // { name: '고경석', number: '24735' },
  // { name: '고성훈', number: '25939' },
  // { name: '고인창', number: '13134' },
  // { name: '고주영', number: '98605' },
  // { name: '고한웅', number: '68916' },
  // { name: '곡낙수', number: '59052' },
  // { name: '구현국', number: '88456' },
  // { name: '국광식', number: '26987' },
  // { name: '권성일', number: '44253' },
  // { name: '권성택', number: '27039' },
  // { name: '권순근', number: '82379' },
  // { name: '권정우', number: '109903' },
  // { name: '권혁재', number: '117334' },
  // { name: '기세휘', number: '45723' },
  // { name: '김결희', number: '89030' },
  // { name: '김광석', number: '35109' },
  // { name: '김국현', number: '78176' },
  // { name: '김규남', number: '77935' },
  // { name: '김규희', number: '106094' },
  // { name: '김기태', number: '56118' },
  // { name: '김덕열', number: '84402' },
  // { name: '김덕우', number: '68954' },
  // { name: '김동연', number: '100000' },
  // { name: '김무현', number: '96682' },
  // { name: '김미정', number: '120862' },
  // { name: '김민철', number: '73108' },
  // { name: '김백규', number: '78949' },
  // { name: '김병준', number: '83849' },
  // { name: '김상화', number: '86852' },
  // { name: '김석권', number: '17839' },
  // { name: '김석원', number: '35570' },
  // { name: '김석화', number: '19245' },
  // { name: '김석환', number: '95978' },
  // { name: '김성기', number: '93898' },
  // { name: '김성수', number: '9024' },
  // { name: '김성은', number: '104122' },
  // { name: '김성호', number: '44750' },
  // { name: '김성훈', number: '100864' },
  // { name: '김세영', number: '19499' },
  // { name: '김승홍', number: '8705' },
  // { name: '김연준', number: '101702' },
  // { name: '김연환', number: '80019' },
  // { name: '김영근', number: '15494' },
  // { name: '김영길', number: '12944' },
  // { name: '김영석', number: '70298' },
  // { name: '김영진', number: '23772' },
  // { name: '김영진', number: '20080' },
  // { name: '김영철', number: '113056' },
  // { name: '김요한', number: '96624' },
  // { name: '김용배', number: '21098' },
  // { name: '김용욱', number: '27657' },
  // { name: '김용하', number: '32615' },
  // { name: '김우경', number: '19356' },
  // { name: '김우섭', number: '27340' },
  // { name: '김유진', number: '63929' },
  // { name: '김은기', number: '77114' },
  // { name: '김응춘', number: '23893' },
  // { name: '김재곤', number: '98035' },
  // { name: '김재우', number: '81366' },
  // { name: '김재인', number: '89491' },
  // { name: '김종명', number: '67762' },
  // { name: '김종서', number: '53322' },
  // { name: '김종환', number: '16337' },
  // { name: '김주원', number: '94018' },
  // { name: '김주형', number: '77723' },
  // { name: '김준규', number: '60520' },
  // { name: '김준혁', number: '52435' },
  // { name: '김준혁', number: '116084' },
  // { name: '김준형', number: '54360' },
  // { name: '김지예', number: '85300' },
  // { name: '김진수', number: '41360' },
  // { name: '김진우', number: '96672' },
  // { name: '김진우', number: '76325' },
  // { name: '김진환', number: '4492' },
  // { name: '김철한', number: '57790' },
  // { name: '김태곤', number: '61220' },
  // { name: '김택균', number: '84634' },
  // { name: '김한구', number: '49374' },
  // { name: '김한조', number: '70287' },
  // { name: '김한중', number: '7172' },
  // { name: '김현석', number: '87206' },
  // { name: '김현수', number: '72089' },
  // { name: '김홍석', number: '50084' },
  // { name: '김홍일', number: '87678' },
  // { name: '김효성', number: '99150' },
  // { name: '김훈', number: '71547' },
  // { name: '나동균', number: '19362' },
  // { name: '나영천', number: '42180' },
  // { name: '나은영', number: '90882' },
  // { name: '남궁식', number: '97769' },
  // { name: '남수봉', number: '58728' },
  // { name: '남승민', number: '81372' },
  // { name: '노시균', number: '69416' },
  // { name: '노시영', number: '47290' },
  // { name: '노태석', number: '38093' },
  // { name: '동은상', number: '46943' },
  // { name: '류재만', number: '6681' },
  // { name: '류정엽', number: '103417' },
  // { name: '류희중', number: '70284' },
  // { name: '명유진', number: '97886' },
  // { name: '모재성', number: '69525' },
  // { name: '문구현', number: '49148' },
  // { name: '문석호', number: '78361' },
  // { name: '문성준', number: '90759' },
  // { name: '민경원', number: '17576' },
  // { name: '박건욱', number: '83307' },
  // { name: '박규형', number: '122766' },
  // { name: '박대환', number: '22085' },
  // { name: '박동권', number: '98545' },
  // { name: '박동하', number: '53163' },
  // { name: '박명철', number: '20431' },
  // { name: '박병윤', number: '13085' },
  // { name: '박병일', number: '24013' },
  // { name: '박보영', number: '87960' },
  // { name: '박봉권', number: '46516' },
  // { name: '박상현', number: '60988' },
  // { name: '박선형', number: '80574' },
  // { name: '박성오', number: '97986' },
  // { name: '박성완', number: '65460' },
  // { name: '박승하', number: '24346' },
  // { name: '박은수', number: '50587' },
  // { name: '박재구', number: '53294' },
  // { name: '박재우', number: '35781' },
  // { name: '박재현', number: '74117' },
  // { name: '박정근', number: '66640' },
  // { name: '박지웅', number: '74680' },
  // { name: '박창식', number: '82258' },
  // { name: '박철', number: '16814' },
  // { name: '박현', number: '43864' },
  // { name: '배성환', number: '82118' },
  // { name: '배용찬', number: '32260' },
  // { name: '배태희', number: '63964' },
  // { name: '백롱민', number: '27816' },
  // { name: '백봉수', number: '7424' },
  // { name: '백우열', number: '92556' },
  // { name: '백운일', number: '104365' },
  // { name: '백정환', number: '72478' },
  // { name: '변재경', number: '59738' },
  // { name: '변진석', number: '20802' },
  // { name: '서동린', number: '87227' },
  // { name: '서만군', number: '47381' },
  // { name: '서보미', number: '90895' },
  // { name: '서영철', number: '99198' },
  // { name: '서인석', number: '20517' },
  // { name: '서현석', number: '79968' },
  // { name: '서형준', number: '100168' },
  // { name: '설정현', number: '10081' },
  // { name: '설철환', number: '55254' },
  // { name: '성건용', number: '71076' },
  // { name: '성낙관', number: '41171' },
  // { name: '손경민', number: '83535' },
  // { name: '손대구', number: '36170' },
  // { name: '손상섭', number: '50318' },
  // { name: '손우종', number: '8321' },
  // { name: '손유석', number: '105132' },
  // { name: '송선호', number: '89862' },
  // { name: '송승용', number: '70312' },
  // { name: '송승한', number: '82936' },
  // { name: '송신영', number: '101299' },
  // { name: '송우진', number: '100082' },
  // { name: '송인철', number: '46163' },
  // { name: '신극선', number: '9914' },
  // { name: '신기철', number: '86372' },
  // { name: '신동필', number: '48189' },
  // { name: '신동혁', number: '55193' },
  // { name: '신명수', number: '25356' },
  // { name: '신상호', number: '86992' },
  // { name: '신진용', number: '90613' },
  // { name: '신현우', number: '74443' },
  // { name: '신혜경', number: '57432' },
  // { name: '신호성', number: '60845' },
  // { name: '심정수', number: '73507' },
  // { name: '심형보', number: '30419' },
  // { name: '심형섭', number: '81528' },
  // { name: '안기영', number: '23724' },
  // { name: '안상태', number: '16584' },
  // { name: '안태주', number: '66380' },
  // { name: '안희창', number: '21638' },
  // { name: '양경무', number: '17595' },
  // { name: '양순재', number: '19373' },
  // { name: '양원용', number: '16037' },
  // { name: '양은진', number: '91539' },
  // { name: '양정덕', number: '60027' },
  // { name: '양정열', number: '18502' },
  // { name: '양채은', number: '99021' },
  // { name: '엄기일', number: '16044' },
  // { name: '엄진섭', number: '58995' },
  // { name: '여현정', number: '85610' },
  // { name: '오갑성', number: '22047' },
  // { name: '오득영', number: '63908' },
  // { name: '오상하', number: '60562' },
  // { name: '오석준', number: '11709' },
  // { name: '오연웅', number: '56593' },
  // { name: '오태석', number: '77203' },
  // { name: '오화영', number: '88059' },
  // { name: '옥재진', number: '58994' },
  // { name: '우경제', number: '90028' },
  // { name: '우상현', number: '30866' },
  // { name: '위서영', number: '94061' },
  // { name: '유대현', number: '34121' },
  // { name: '윤근철', number: '19880' },
  // { name: '윤병민', number: '56985' },
  // { name: '윤성호', number: '34805' },
  // { name: '윤원준', number: '43590' },
  // { name: '윤을식', number: '40253' },
  // { name: '윤인대', number: '46436' },
  // { name: '윤인식', number: '72930' },
  // { name: '윤창운', number: '68555' },
  // { name: '윤청민', number: '100636' },
  // { name: '은석찬', number: '62418' },
  // { name: '이경석', number: '58610' },
  // { name: '이경아', number: '94804' },
  // { name: '이경진', number: '86451' },
  // { name: '이경태', number: '98150' },
  // { name: '이규원', number: '5796' },
  // { name: '이근철', number: '53978' },
  // { name: '이대광', number: '61127' },
  // { name: '이동락', number: '21106' },
  // { name: '이동원', number: '72320' },
  // { name: '이동철', number: '47506' },
  // { name: '이두영', number: '29335' },
  // { name: '이두형', number: '10635' },
  // { name: '이명철', number: '85197' },
  // { name: '이민영', number: '93629' },
  // { name: '이백권', number: '32166' },
  // { name: '이병민', number: '30592' },
  // { name: '이병일', number: '30128' },
  // { name: '이삼용', number: '24638' },
  // { name: '이상목', number: '25011' },
  // { name: '이세일', number: '10496' },
  // { name: '이승렬', number: '56647' },
  // { name: '이영대', number: '60839' },
  // { name: '이영만', number: '20023' },
  // { name: '이영호', number: '4951' },
  // { name: '이원', number: '60931' },
  // { name: '이원구', number: '14399' },
  // { name: '이원재', number: '55928' },
  // { name: '이익준', number: '49693' },
  // { name: '이일재', number: '71574' },
  // { name: '이장혁', number: '54780' },
  // { name: '이재우', number: '87740' },
  // { name: '이종원', number: '23357' },
  // { name: '이종훈', number: '53020' },
  // { name: '이준석', number: '107339' },
  // { name: '이준용', number: '84229' },
  // { name: '이준우', number: '95126' },
  // { name: '이준욱', number: '89223' },
  // { name: '이준호', number: '67448' },
  // { name: '이중호', number: '73102' },
  // { name: '이진규', number: '59457' },
  // { name: '이태근', number: '96869' },
  // { name: '이태열', number: '96757' },
  // { name: '이택종', number: '16779' },
  // { name: '이택호', number: '6766' },
  // { name: '이형철', number: '95634' },
  // { name: '이혜경', number: '25509' },
  // { name: '이홍기', number: '47264' },
  // { name: '이훈주', number: '93316' },
  // { name: '임대원', number: '77984' },
  // { name: '임소영', number: '62799' },
  // { name: '임수아', number: '68350' },
  // { name: '임수연', number: '106554' },
  // { name: '임중혁', number: '38798' },
  // { name: '임효섭', number: '73685' },
  // { name: '장용준', number: '71063' },
  // { name: '장인규', number: '3832' },
  // { name: '장재훈', number: '76729' },
  // { name: '장학', number: '37755' },
  // { name: '전병준', number: '77058' },
  // { name: '전여름', number: '96267' },
  // { name: '전영우', number: '70359' },
  // { name: '전영준', number: '57203' },
  // { name: '전태준', number: '12387' },
  // { name: '전홍배', number: '108789' },
  // { name: '정규진', number: '87069' },
  // { name: '정대균', number: '124191' },
  // { name: '정복기', number: '107441' },
  // { name: '정성균', number: '26723' },
  // { name: '정성노', number: '62684' },
  // { name: '정성호', number: '71449' },
  // { name: '정연익', number: '92609' },
  // { name: '정연진', number: '100036' },
  // { name: '정영덕', number: '16438' },
  // { name: '정우식', number: '93657' },
  // { name: '정운혁', number: '96756' },
  // { name: '정윤규', number: '23988' },
  // { name: '정의철', number: '68326' },
  // { name: '정재아', number: '101900' },
  // { name: '정재용', number: '64285' },
  // { name: '정재인', number: '41465' },
  // { name: '정재호', number: '29472' },
  // { name: '정재호', number: '101708' },
  // { name: '정지은', number: '92613' },
  // { name: '정지혁', number: '55809' },
  // { name: '정찬민', number: '29979' },
  // { name: '정창은', number: '28200' },
  // { name: '정철훈', number: '21723' },
  // { name: '정현욱', number: '92720' },
  // { name: '정호윤', number: '51415' },
  // { name: '조백현', number: '18304' },
  // { name: '조병채', number: '27421' },
  // { name: '조성필', number: '23834' },
  // { name: '조세흠', number: '22940' },
  // { name: '조수영', number: '39048' },
  // { name: '조영후', number: '107840' },
  // { name: '조인창', number: '15571' },
  // { name: '조재영', number: '94929' },
  // { name: '조정목', number: '92294' },
  // { name: '조태영', number: '58922' },
  // { name: '조태희', number: '103331' },
  // { name: '조해석', number: '12780' },
  // { name: '주홍실', number: '69209' },
  // { name: '진웅식', number: '77089' },
  // { name: '차상면', number: '29257' },
  // { name: '차지훈', number: '63176' },
  // { name: '차한규', number: '99777' },
  // { name: '천지선', number: '63052' },
  // { name: '최강영', number: '84518' },
  // { name: '최동일', number: '78986' },
  // { name: '최문섭', number: '69214' },
  // { name: '최민석', number: '88738' },
  // { name: '최석현', number: '13054' },
  // { name: '최영웅', number: '65572' },
  // { name: '최오규', number: '23721' },
  // { name: '최우영', number: '85472' },
  // { name: '최윤석', number: '49500' },
  // { name: '최재훈', number: '80197' },
  // { name: '최종우', number: '58318' },
  // { name: '최준', number: '13438' },
  // { name: '최준호', number: '110492' },
  // { name: '최지안', number: '108171' },
  // { name: '최창용', number: '73120' },
  // { name: '최현곤', number: '58596' },
  // { name: '최홍림', number: '57074' },
  // { name: '최환준', number: '71830' },
  // { name: '탁관철', number: '14116' },
  // { name: '탁민성', number: '38609' },
  // { name: '하성윤', number: '48365' },
  // { name: '한기환', number: '18929' },
  // { name: '한상철', number: '90118' },
  // { name: '한소은', number: '99278' },
  // { name: '한승규', number: '34144' },
  // { name: '한승범', number: '78964' },
  // { name: '한정규', number: '95708' },
  // { name: '한현호', number: '95604' },
  // { name: '한형민', number: '92621' },
  // { name: '한형일', number: '12272' },
  // { name: '허은', number: '16727' },
  // { name: '허찬영', number: '56314' },
  // { name: '홍기용', number: '90138' },
  // { name: '홍민기', number: '104938' },
  // { name: '홍성범', number: '43795' },
  // { name: '홍승은', number: '82065' },
  // { name: '홍종원', number: '67028' },
  // { name: '홍준표', number: '50147' },
  // { name: '황건', number: '26107' },
  // { name: '황나현', number: '95432' },
  // { name: '황동연', number: '81582' },
  // { name: '황소민', number: '37846' },
  // { name: '황영중', number: '27569' },
  // { name: '황은아', number: '58329' },
  // { name: '황재하', number: '54951' },
  // { name: '황종익', number: '23278' },

  '46993',
  '78209',
  '62187',
  '46195',
  '49774',
  '68930',
  '90143',
  '24735',
  '25939',
  '13134',
  '98605',
  '68916',
  '59052',
  '88456',
  '26987',
  '44253',
  '27039',
  '82379',
  '109903',
  '117334',
  '45723',
  '89030',
  '35109',
  '78176',
  '77935',
  '106094',
  '56118',
  '84402',
  '68954',
  '100000',
  '96682',
  '120862',
  '73108',
  '78949',
  '83849',
  '86852',
  '17839',
  '35570',
  '19245',
  '95978',
  '93898',
  '9024',
  '104122',
  '44750',
  '100864',
  '19499',
  '8705',
  '101702',
  '80019',
  '15494',
  '12944',
  '70298',
  '23772',
  '20080',
  '113056',
  '96624',
  '21098',
  '27657',
  '32615',
  '19356',
  '27340',
  '63929',
  '77114',
  '23893',
  '98035',
  '81366',
  '89491',
  '67762',
  '53322',
  '16337',
  '94018',
  '77723',
  '60520',
  '52435',
  '116084',
  '54360',
  '85300',
  '41360',
  '96672',
  '76325',
  '4492',
  '57790',
  '61220',
  '84634',
  '49374',
  '70287',
  '7172',
  '87206',
  '72089',
  '50084',
  '87678',
  '99150',
  '71547',
  '19362',
  '42180',
  '90882',
  '97769',
  '58728',
  '81372',
  '69416',
  '47290',
  '38093',
  '46943',
  '6681',
  '103417',
  '70284',
  '97886',
  '69525',
  '49148',
  '78361',
  '90759',
  '17576',
  '83307',
  '122766',
  '22085',
  '98545',
  '53163',
  '20431',
  '13085',
  '24013',
  '87960',
  '46516',
  '60988',
  '80574',
  '97986',
  '65460',
  '24346',
  '50587',
  '53294',
  '35781',
  '74117',
  '66640',
  '74680',
  '82258',
  '16814',
  '43864',
  '82118',
  '32260',
  '63964',
  '27816',
  '7424',
  '92556',
  '104365',
  '72478',
  '59738',
  '20802',
  '87227',
  '47381',
  '90895',
  '99198',
  '20517',
  '79968',
  '100168',
  '10081',
  '55254',
  '71076',
  '41171',
  '83535',
  '36170',
  '50318',
  '8321',
  '105132',
  '89862',
  '70312',
  '82936',
  '101299',
  '100082',
  '46163',
  '9914',
  '86372',
  '48189',
  '55193',
  '25356',
  '86992',
  '90613',
  '74443',
  '57432',
  '60845',
  '73507',
  '30419',
  '81528',
  '23724',
  '16584',
  '66380',
  '21638',
  '17595',
  '19373',
  '16037',
  '91539',
  '60027',
  '18502',
  '99021',
  '16044',
  '58995',
  '85610',
  '22047',
  '63908',
  '60562',
  '11709',
  '56593',
  '77203',
  '88059',
  '58994',
  '90028',
  '30866',
  '94061',
  '34121',
  '19880',
  '56985',
  '34805',
  '43590',
  '40253',
  '46436',
  '72930',
  '68555',
  '100636',
  '62418',
  '58610',
  '94804',
  '86451',
  '98150',
  '5796',
  '53978',
  '61127',
  '21106',
  '72320',
  '47506',
  '29335',
  '10635',
  '85197',
  '93629',
  '32166',
  '30592',
  '30128',
  '24638',
  '25011',
  '10496',
  '56647',
  '60839',
  '20023',
  '4951',
  '60931',
  '14399',
  '55928',
  '49693',
  '71574',
  '54780',
  '87740',
  '23357',
  '53020',
  '107339',
  '84229',
  '95126',
  '89223',
  '67448',
  '73102',
  '59457',
  '96869',
  '96757',
  '16779',
  '6766',
  '95634',
  '25509',
  '47264',
  '93316',
  '77984',
  '62799',
  '68350',
  '106554',
  '38798',
  '73685',
  '71063',
  '3832',
  '76729',
  '37755',
  '77058',
  '96267',
  '70359',
  '57203',
  '12387',
  '108789',
  '87069',
  '124191',
  '107441',
  '26723',
  '62684',
  '71449',
  '92609',
  '100036',
  '16438',
  '93657',
  '96756',
  '23988',
  '68326',
  '101900',
  '64285',
  '41465',
  '29472',
  '101708',
  '92613',
  '55809',
  '29979',
  '28200',
  '21723',
  '92720',
  '51415',
  '18304',
  '27421',
  '23834',
  '22940',
  '39048',
  '107840',
  '15571',
  '94929',
  '92294',
  '58922',
  '103331',
  '12780',
  '69209',
  '77089',
  '29257',
  '63176',
  '99777',
  '63052',
  '84518',
  '78986',
  '69214',
  '88738',
  '13054',
  '65572',
  '23721',
  '85472',
  '49500',
  '80197',
  '58318',
  '13438',
  '110492',
  '108171',
  '73120',
  '58596',
  '57074',
  '71830',
  '14116',
  '38609',
  '48365',
  '18929',
  '90118',
  '99278',
  '34144',
  '78964',
  '95708',
  '95604',
  '92621',
  '12272',
  '16727',
  '56314',
  '90138',
  '104938',
  '43795',
  '82065',
  '67028',
  '50147',
  '26107',
  '95432',
  '81582',
  '37846',
  '27569',
  '58329',
  '54951',
  '23278',
];
